import React, {useState, useEffect} from 'react';
import ActionItemCreate from './ActionItemCreate.mjs';
import ShortListNavbar from './ShortListNavbar.mjs';
import ShortListActionItemList from './ShortListActionItemList.mjs';
import ShortListInformation from './ShortListInformation.mjs';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = 0;

export default function ShortListColumn() 
{
    const { app_user } = useCTAL();

    const [display_type, setDisplayType] = useState("action-item-list");
    const [display, setDisplay] = useState(<> <ShortListActionItemList user_id={app_user.UserID} /> </>);

    useEffect(() =>
    {
        if (!app_user) return;

        show_display(display_type, true); //Need to reset team and user_id on Context value change
        if (DEBUG) console.log(`ShortListColumn** - UserID from Context: ${app_user.UserID}`);
    }, [ app_user ]);

    const show_display = (d_type, reset=false) => { 

        if ((display_type == d_type) && (!reset))
            return;

        switch (d_type)
        {
            case "action-item-list":
            default:
                setDisplay( <> <ShortListActionItemList user_id={app_user.UserID} /> </> ); 
                break;
            case "short-list-information":
                setDisplay( <> <ShortListInformation /> </> ); 
                break;
        }

        setDisplayType(d_type);
    }

    return (
        <>
            <ActionItemCreate show_display={show_display} />
            <ShortListNavbar app_user={app_user} show_display={show_display} />
            {display}
        </>
    );
}
